import { Navigate, Route, Routes } from "react-router-dom";

export const UnauthenticatedRoutes = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="/sign-up" replace />} />
    </Routes>
  );
};
